// extracted by mini-css-extract-plugin
export default {"home":"Home_home__9EQkZ","home_big_img_div":"Home_home_big_img_div__zDfHq"};